import gql from "graphql-tag";

export const ACTIVATE_ORGANIZATION = gql`
  mutation ActivateOrganization($where: OrganizationWhereInput) {
    activateOrganization(where: $where) {
      id
    }
  }
`;

export const CREATE_ORGANIZATION = gql`
  mutation CreateOrganization($data: OrganizationDataInput) {
    createOrganization(data: $data) {
      id
    }
  }
`;

const organizations = { ACTIVATE_ORGANIZATION, CREATE_ORGANIZATION };

export default organizations;
